<template>

  <section class="container">
    <section class="page-content">
      <nuxt/>
    </section>
    <no-ssr>
       <scroll-top-arrow ref="scrollTopArrow"/>
    </no-ssr>
    <no-ssr>
       <page-footer ref="pageFooter"/>
    </no-ssr>
  </section>

</template>

<script>
  import PageFooter from '../components/footer/PageFooter.vue'
  //import FloatingMenu from '~/components/shared/FloatingMenu'
 // import ScrollTopArrow from '~/components/shared/ScrollTopArrow'

  export default {
    transition: 'page',
    created() {
      if (process.client) {
        window.addEventListener('scroll', this.handleScroll);
        if ('ontouchstart' in document.documentElement) {
          document.querySelectorAll('body')[0].className = 'touch';
        }
      }
    },
    computed: {
      counters() {
        return this.$store.getters['main/counters']['item'] || [];
      },
    },
    components: {
      PageFooter,
    //  FloatingMenu,
    },
    mounted() {
      if(!this.$store.state.main.counters.loaded) this.$store.dispatch('main/fetchCounters');
    },
  }
</script>

<style lang="scss">
  /*body {*/
  /*  background: url("/123.jpg");*/
  /*  background-size: 100% 100%;*/
  /*}*/
  .container {
    min-height: 100vh;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between; -ms-flex-pack: justify;
  }
</style>



// WEBPACK FOOTER //
// layouts/default.vue